import { Avatar, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../auth/useAuth';
import type { Me } from '../api/client';

/** 側欄左下使用者選單（深色）：角色、我的帳號、登出；收折時只顯示頭像。 */
export default function SiderUser({ me, collapsed }: { me: Me; collapsed: boolean }) {
  const navigate = useNavigate();
  const logout = useLogout();
  const name = me.displayName || me.email || '使用者';

  return (
    <div className="mt-auto border-t border-white/10 p-2">
      <Dropdown
        trigger={['click']}
        placement="topLeft"
        menu={{
          items: [
            { key: 'role', label: `角色：${me.roles.join(', ') || '無'}`, disabled: true },
            { type: 'divider' },
            { key: 'account', icon: <UserOutlined />, label: '我的帳號', onClick: () => navigate('/account') },
            { key: 'logout', icon: <LogoutOutlined />, label: '登出', onClick: () => logout.mutate() },
          ],
        }}
      >
        <button
          type="button"
          className={`flex w-full items-center gap-2 rounded-lg py-2 text-left text-white/85 transition-colors hover:bg-white/10 ${
            collapsed ? 'justify-center px-0' : 'px-2'
          }`}
        >
          <Avatar size="small" style={{ background: '#dd7900' }}>
            {name[0]?.toUpperCase() ?? 'U'}
          </Avatar>
          {!collapsed && <span className="truncate text-sm">{name}</span>}
        </button>
      </Dropdown>
    </div>
  );
}
